import { Routes } from '@angular/router';
import { LoginComponent } from './pages/public/login/login.component';
import { ForgotPasswordComponent } from './pages/public/forgotten-passsword/forgot-password.component';
import { HomeComponent } from './pages/protected/home/home.component';
import { PlatformInsightsComponent } from './pages/protected/platform-insights/platform-insights.component';
import { ProjectOwnersComponent } from './pages/protected/project-owners/project-owners.component';
import { ProjectOwnerEditComponent } from './pages/protected/project-owner-edit/project-owner-edit.component';
import { AdminUsersComponent } from './pages/protected/admin-users/admin-users.component';
import { AdminUserEditComponent } from './pages/protected/admin-user-edit/admin-user-edit.component';
import { ProjectsComponent } from './pages/protected/projects/projects.component';
import { ProjectEditComponent } from './pages/protected/project-edit/project-edit.component';
import { CategoriesComponent } from './pages/protected/categories/categories.component';
import { BlockchainsComponent } from './pages/protected/blockchains/blockchains.component';
import { SuccessStoriesComponent } from './components/success-stories/success-stories.component';
import { LearnMoreComponent } from './components/learn-more/learn-more.component';
import { CommunityComponent } from './components/community/community.component';
import { UserMlpComponent } from './pages/protected/user-mlp/user-mlp.component';
import { authenticationGuard } from './guards/login.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  {
    path: '',
    component: HomeComponent,
    canActivate: [authenticationGuard()],
    children: [
      { path: 'platform-insights', component: PlatformInsightsComponent },
      { path: 'project-owners', component: ProjectOwnersComponent },
      { path: 'project-owners/:id', component: ProjectOwnerEditComponent },
      { path: 'admin-users', component: AdminUsersComponent },
      { path: 'admin-users/:id', component: AdminUserEditComponent },
      { path: 'projects', component: ProjectsComponent },
      { path: 'projects/:id', component: ProjectEditComponent },
      { path: 'categories', component: CategoriesComponent },
      { path: 'user-mlp', component: UserMlpComponent },
      { path: 'blockchains', component: BlockchainsComponent },
      { path: 'success-stories', component: SuccessStoriesComponent },
      { path: 'learn-more', component: LearnMoreComponent },
      { path: 'community', component: CommunityComponent },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'platform-insights',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
